import React from 'react';
import {CMSLandingSection} from '@tempo/landing';
import {Box, Button} from '@tempo/core';
import Link from 'next/link';
import {StrapiOptimizedImage} from './StrapiOptimizedImage';
import {useResolveTranslations} from '../hooks/useResolveTranslations';

type StrapiSectionBlockProps = {
	strapiBlockData: any;
	translationNamespace: string;
};

export const StrapiSectionBlock: React.FC<StrapiSectionBlockProps> = ({
	strapiBlockData,
	translationNamespace,
}) => {
	const resolve = useResolveTranslations(translationNamespace);
	return (
		<Box bg="background.neutral.secondary.default" py="spacing.3xl" w="100%">
			<Box maxWidth={{base: '100%', md: '1440px'}} mx="auto">
				<CMSLandingSection
					title={resolve(strapiBlockData.title).replace(/<[^>]+>/g, '')}
					description={resolve(strapiBlockData.description).replace(
						/<[^>]+>/g,
						'',
					)}
					cta={
						strapiBlockData.cta ? (
							<Button as={Link} href={strapiBlockData.cta?.href}>
								{resolve(strapiBlockData.cta?.label)}
							</Button>
						) : undefined
					}
					image={
						strapiBlockData.image?.src ? (
							<Box w="100%" maxHeight={{base: '220px', md: '400px'}}>
								<StrapiOptimizedImage
									image={strapiBlockData.image.src}
									alt={resolve(strapiBlockData.image?.alt)}
									sizes="(max-width: 767px) 100vw, 50vw"
									style={{
										width: '100%',
										maxHeight: 'inherit',
										objectFit: 'contain',
									}}
								/>
							</Box>
						) : undefined
					}
					imagePosition={strapiBlockData.imagePosition}
				/>
			</Box>
		</Box>
	);
};
